import { defineComponent as _defineComponent } from 'vue'
import { useContext, computed } from '@nuxtjs/composition-api';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import WarRoomAchievement from '@/components/partials/war-room/WarRoomAchievement.vue';
import WarRoomPostActions from '@/components/partials/war-room/WarRoomPostActions.vue';
import { achievementSizes } from '@/components/partials/war-room/constants';
import { initials as initialsUtils } from '@/components/utils/core/string';
import type { IPost } from '@/types/community';

type WarRoomPostAuthorProps = {
  post: IPost;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostAuthor',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
  post: IPost;
};



const { $device, $auth } = useContext();

const achievementSize = achievementSizes.SMALL;
const maxVisibleAchievements = $device.isMobile ? 2 : 3;

const profileUrl = computed(() => {
  if (props.post.is_anonymous) {
    return `/war-room/profile/${props.post.author?.username}`;
  }
  const isSameUser = props.post.author?.slug === $auth.user?.slug && props.post.author?.slug;
  if (props.post.author?.portfolio_configuration?.is_public || isSameUser) {
    return `/p/${props.post.author?.slug}`;
  }
});

const username = computed(() => {
  if (props.post.is_anonymous) return props.post.author?.username;
  if (!profileUrl.value) return `${props.post.author?.firstname} ${props.post.author?.lastname?.substring(0, 1)}`;
  return `${props.post.author?.firstname} ${props.post.author?.lastname}`;
});

const position = computed(() => {
  if (!props.post.author?.position) return '';

  let position = props.post.author.position;

  if (props.post.author.current_company) {
    position += ` at ${props.post.author.current_company}`;
  }

  return position;
});

const disabledLinkHint = computed(() => {
  if (props.post.author?.firstname) {
    return `${props.post.author?.firstname?.trim()}'s profile is not public`;
  }

  return `Author's profile is not public`;
});

const initials = computed(() => initialsUtils(username.value));
const achievements = computed(() => props.post.author?.achievements?.slice(0, maxVisibleAchievements) || []);
const additionalAchievement = computed(() => {
  const remainingCount = Math.max(0, (props.post.author?.achievements?.length || 0) - maxVisibleAchievements);
  if (remainingCount < 1) return undefined;
  return {
    title: `+${remainingCount}`,
    slug: '',
    level: 'no_level',
  };
});
const linkComponent = computed(() => (profileUrl.value ? 'nuxt-link' : 'a'));

return { __sfc: true,props, $device, $auth, achievementSize, maxVisibleAchievements, profileUrl, username, position, disabledLinkHint, initials, achievements, additionalAchievement, linkComponent, Avatar, WarRoomAchievement, WarRoomPostActions }
}

})